module.exports = __webpack_public_path__ + "static/media/OrdemServico1.fbd1d515.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancOrdemServicos/OrdemServico1.png
// module id = 1764
// module chunks = 0